export const fieldNames = {
  passwordField: 'password',
  confirmPasswordField: 'confirmPassword',
  mfaPhone: 'mfaPhone',
};

export const DEFAULT_VALIDATION_REGEX = new RegExp(
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@!%*#?&])[a-zA-Z\\d$@!%*#?&]{12,}$',
);
